"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var get = require('lodash/get');

var inRange = require('lodash/inRange');

var requestError = require('@flowio/request/lib/error');

var requestSuccess = require('@flowio/request/lib/success');

var ShopifySessionClient = require('./shopify');

var OrganizationSessionClient = require('./organization');

var SessionClient = /*#__PURE__*/function () {
  function SessionClient(_ref) {
    var apiBaseUri = _ref.apiBaseUri;

    _classCallCheck(this, SessionClient);

    this.apiBaseUri = apiBaseUri;
    this.shopifySessionClient = new ShopifySessionClient({
      apiBaseUri: this.apiBaseUri
    });
    this.organizationSessionClient = new OrganizationSessionClient({
      apiBaseUri: this.apiBaseUri
    });
  }

  _createClass(SessionClient, [{
    key: "getClient",
    value: function getClient(options) {
      var integration = SessionClient.getIntegration(options);
      var client;

      if (integration === 'shopify') {
        client = this.shopifySessionClient;
      } else {
        client = this.organizationSessionClient;
      }

      return client;
    }
  }, {
    key: "createSession",
    value: function createSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var integration = SessionClient.getIntegration(options);

      if (integration === 'shopify') {
        var shop = get(options, 'shop');
        this.shopifySessionClient.createSession(shop, function (status, response) {
          if (SessionClient.requestSuccessful(status)) {
            requestSuccess(options, response);
          } else {
            requestError(options, SessionClient.formatApiErrorResponse(status, response));
          }
        });
      } else {
        var organizationId = get(options, 'organizationId');
        this.organizationSessionClient.createSession(organizationId, function (status, response) {
          if (SessionClient.requestSuccessful(status)) {
            requestSuccess(options, response);
          } else {
            requestError(options, SessionClient.formatApiErrorResponse(status, response));
          }
        });
      }
    }
  }, {
    key: "getSession",
    value: function getSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionId = get(options, 'sessionId');
      var client = this.getClient(options);
      client.getSession(sessionId, function (status, response) {
        if (SessionClient.requestSuccessful(status)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }, {
    key: "resetSession",
    value: function resetSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionId = get(options, 'sessionId');
      var client = this.getClient(options);
      var form = {
        country: get(options, 'geo.country'),
        currency: get(options, 'geo.currency'),
        language: get(options, 'geo.language'),
        experience: get(options, 'experience'),
        locale: get(options, 'geo.locale'),
        attributes: get(options, 'attributes'),
        experiment: get(options, 'experiment')
      };
      client.resetSession(sessionId, form, function (status, response) {
        if (SessionClient.requestSuccessful(status)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }, {
    key: "clearSession",
    value: function clearSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionId = get(options, 'sessionId');
      var client = this.getClient(options);
      client.clearSession(sessionId, function (status, response) {
        if (SessionClient.requestSuccessful(status)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }], [{
    key: "getIntegration",
    value: function getIntegration() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionType = get(options, 'sessionType', 'organization');
      var fallbackIntegration = sessionType === 'shopify' ? sessionType : 'default';
      return get(options, 'integration', fallbackIntegration);
    }
  }, {
    key: "requestSuccessful",
    value: function requestSuccessful(status) {
      return inRange(status, 200, 300);
    }
  }, {
    key: "formatApiErrorResponse",
    value: function formatApiErrorResponse(status, response) {
      var messages = get(response, 'error.messages', []);
      var code = get(response, 'error.code');
      return "Got error back from server status[".concat(status, "] code[").concat(code, "] message[").concat(messages.join(', '), "]");
    }
  }]);

  return SessionClient;
}();

module.exports = SessionClient;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/client/session.js
// module id = 691
// module chunks = 0 1